var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 121,
    viewBox: "0 0 62 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3156 89.2318C61.3156 106.375 46.9852 120.82 29.8424 120.82C17.234 120.82 5.71612 113.109 0.339844 100.367L6.3475 97.8032C10.748 108.326 19.7021 114.2 29.8615 114.2C43.8284 114.2 54.8488 103.179 54.8488 89.2318C54.8488 75.2841 43.8284 64.1298 29.8615 64.1298L28.9623 60.131L29.8615 59.9588C43.8284 57.5098 54.8488 46.4895 54.8488 32.4078C54.8488 18.3262 43.8284 7.43971 29.8615 7.43971C19.7021 7.43971 10.7671 13.3134 6.3475 23.8364L0.339844 21.2726C5.73525 8.53029 17.234 0.819824 29.8424 0.819824C46.9852 0.819824 61.3156 15.265 61.3156 32.4078C61.3156 45.7433 52.7442 57.3759 44.058 60.8198C52.7442 64.2446 61.3156 75.8772 61.3156 89.2318Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/NUMBER_3.a605fb270295b410d76f12b99c801b37.svg";
export { ForwardRef as ReactComponent };